"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a user info field failed validation
 * @param {string} field the field that failed validation
 * @param {string} message the validation message
 */
class UserInfoBodyNotValidError extends client_library_1.ExtendableError {
    constructor(field, message) {
        super(`user info: ${field} failed validation. ${message}`);
        this.field = field;
    }
}
exports.default = UserInfoBodyNotValidError;
//# sourceMappingURL=UserInfoBodyNotValidError.js.map